export default __webpack_public_path__ + "static/brand-15-3e93a93f2df4c2abd7dfa483b3c3670e.png";